import React from "react";

function Anchor(props){
    return <a href={props.link} >{props.text}</a>
   }

export default Anchor;